module.exports = __webpack_public_path__ + "static/media/phone_fade.9c859c3e.png";